{
  "removeButtonLabel": "Usuń",
  "removeDescription": "Naciśnij Usuń, aby usunąć znacznik."
}
